import type { ReactNode } from 'react';

import type {
  AnalyticsWebClient,
  FabricChannel,
} from '@atlaskit/analytics-listeners';
import FabricAnalyticsListeners from '@atlaskit/analytics-listeners';
import { getAnalyticsClientMemberIdProxy } from '@trello/atlassian-analytics';

export const ConditionalFabricAnalyticsListeners = ({
  shouldIgnoreFabricAnalyticsListeners,
  excludedChannels,
  children,
}: {
  excludedChannels?: FabricChannel[];
  shouldIgnoreFabricAnalyticsListeners: boolean;
  children: ReactNode | undefined;
}): ReactNode => {
  return shouldIgnoreFabricAnalyticsListeners ? (
    children
  ) : (
    <FabricAnalyticsListeners
      client={getAnalyticsClientMemberIdProxy() as AnalyticsWebClient}
      excludedChannels={excludedChannels}
    >
      {children}
    </FabricAnalyticsListeners>
  );
};
